import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ClinicaService } from '../clinica.service';
import { AuthService } from '../../admin/auth.service';

@Component({
  templateUrl: './gerenciar-clinica.component.html',
})
export class GerenciarClinicaComponent extends WebPage implements OnInit {

  clinicaUnidades;

  constructor(private clinicaService: ClinicaService, private authService: AuthService, messageService: MessageService) {
    super(messageService);
   }

  ngOnInit() {
    const usuario = this.authService.informacoesUsuario();
    // console.log(usuario);
    const observable = (usuario.Perfil !== '#GESTORUNIDADEOPERACIONAL' && usuario.Perfil !== '#ADMINISTRATIVOUNIDADEOPERACIONAL')
      ? this.clinicaService.getAllClinicaUnidades()
      : this.clinicaService.getClinicaUnidadesByUnidade(usuario.IdUnidade);

    this.isLoading = true;
    observable
      .finally(() => this.isLoading = false)
      .subscribe(
        clinicaUnidades => this.clinicaUnidades = clinicaUnidades,
        error => this.gerenciaErro(error)
      );
  }

  exibirGerenciaDeTermos(clinicaUnidade) {
    return (clinicaUnidade.dataValidadeCredenciamento < new Date() && clinicaUnidade.statusCredenciamento.descricao !== 'Cadastrado');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clinica/gerenciar-clinica/gerenciar-clinica.component.ts